import _Promise from "babel-runtime/core-js/promise";
export var wait = function wait(duration) {
  return new _Promise(function (resolve, reject) {
    setTimeout(resolve, duration);
  });
};
//# sourceMappingURL=delay.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/delay.js
// module id = 746
// module chunks = 0